// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"360aa5e1","633":"076d8608","981":"d8fb5bcf"}[chunkId] + ".chunk.js";
};